import { forwardRef, type SVGProps } from 'react';

const HookshotIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  function HookshotIcon(props, ref) {
    return (
      <svg
        ref={ref}
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M8.02101 0.0209961C12.4276 0.0209961 15.9999 3.59328 15.9999 7.99992C15.9999 12.4066 12.4276 15.9788 8.02101 15.9788C6.57736 15.9788 5.22326 15.5954 4.05497 14.9249C3.98771 14.8863 3.97241 14.7964 4.02195 14.7367L11.8279 5.33356C12.7744 4.19335 11.9635 2.46632 10.4817 2.46632H2.57014C2.4586 2.46632 2.40266 2.3334 2.48295 2.25597C3.9179 0.872133 5.87006 0.0209961 8.02101 0.0209961Z"
          fill="currentColor"
        />
        <path
          d="M4.21729 11.1726C4.85722 11.1726 5.19371 11.9316 4.76404 12.4058L3.07893 14.2657C2.04111 13.4549 1.20852 12.3935 0.672119 11.1726H4.21729Z"
          fill="currentColor"
        />
        <path
          d="M7.42364 7.2937C8.1436 7.2937 8.53241 8.13781 8.06448 8.68496L7.46961 9.38053C7.06911 9.84884 6.48374 10.1185 5.86753 10.1185H0.295249C0.102895 9.43115 0 8.70646 0 7.95773C0 7.73413 0.00918211 7.51267 0.0271739 7.2937H7.42364Z"
          fill="currentColor"
        />
        <path
          d="M10.3143 3.49927C11.0355 3.49927 11.4239 4.34603 10.9533 4.89263L10.3699 5.57027C9.96944 6.03543 9.38613 6.30296 8.77234 6.30296H0.171387C0.385821 5.28342 0.794387 4.33538 1.35662 3.49927H10.3143Z"
          fill="currentColor"
        />
      </svg>
    );
  },
);

export default HookshotIcon;
